import React from 'react';
import Button1 from 'Components/ComponentLibrary/Components/Buttons/Button1';
import ConfirmationDialog from 'Components/UI/ConfirmationDialog/NewDialog';
import PropTypes from 'prop-types';
import useResetButton from './useResetButton';

const ResetButton = () => {
  const {
    onConfirm,
    onCancel,
    onClick,
    showConfirm,
    isResetting,
  } = useResetButton();

  return (
    <>
      <Button1
        onClick={onClick}
        color={'primary'}
        size={'small'}
        variant={'outlined'}
        round
      >
        {'Reset Money Movement'}
      </Button1>
      {showConfirm ? (
        <ConfirmationDialog
          message={'This will reset all automated transfers and any manual changes that were made to them.'}
          confirmLabel={'Reset'}
          onCancel={onCancel}
          onConfirm={onConfirm}
          loading={isResetting}
        />
      ) : null}
    </>
  );
};

ResetButton.propTypes = {
  resource: PropTypes.object.isRequired,
};
export default ResetButton;
